import React from 'react';
import { Box, createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DailySurgeonCalendarFilled from '@components/FindATime/DailySurgeonCalendarSection/DailySurgeonCalendarFilled';
import {
	SelectedReleaseInfo
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext.types';
import { BLOCK_RELEASE_MAX_HEIGHT } from '@theme/themeConstants';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			gridArea: 'schedule',
			maxHeight: BLOCK_RELEASE_MAX_HEIGHT,
		},
	}),
);

interface ScheduleSectionProps {
	selectedReleaseInfo: SelectedReleaseInfo;
}

export const ScheduleSection = ({ selectedReleaseInfo }: ScheduleSectionProps) => {
	const classes = useStyles();

	if (!selectedReleaseInfo.blockInfo) return null;

	return (
		<Box className={classes.root}>
			<DailySurgeonCalendarFilled key={selectedReleaseInfo.blockInfo.id} blockInfo={selectedReleaseInfo.blockInfo} />
		</Box>
	);
};
